import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from "recharts";
import { Warning, FileText, ClipboardText } from "@phosphor-icons/react";
import { STATUS, fmtBRL } from "@/lib/medicoes";

const Kpi = ({ label, value, accent, testid }) => (
  <div className="tce-card p-5" data-testid={testid}>
    <div className="uppercase-label !text-[10px]">{label}</div>
    <div className="font-heading text-base sm:text-xl xl:text-2xl mt-2 tracking-tight font-mono break-all" style={accent ? { color: accent } : undefined}>{value}</div>
  </div>
);

export default function FornecedorPainel() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/fornecedor/painel").then((r) => setD(r.data)); }, []);
  if (!d) return <div className="text-[#94A3B8]">Carregando…</div>;
  const t = d.totais;
  const chart = d.por_contrato.map((c) => ({ name: c.numero, Atualizado: c.valor_atualizado, Aprovado: c.valor_aprovado, Saldo: c.saldo }));
  return (
    <div className="space-y-8" data-testid="fornecedor-painel">
      <div>
        <div className="uppercase-label">Área do Fornecedor</div>
        <h1 className="font-heading text-4xl tracking-tight mt-2">Painel de contratos</h1>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Kpi label="Contratos ativos" value={`${d.contratos_ativos} / ${d.contratos_total}`} testid="kpi-ativos" />
        <Kpi label="Valor inicial" value={fmtBRL(t.valor_inicial)} testid="kpi-inicial" />
        <Kpi label="Valor atualizado" value={fmtBRL(t.valor_atualizado)} accent="#FFDF00" testid="kpi-atualizado" />
        <Kpi label="Saldo contratual" value={fmtBRL(t.saldo_contratual)} accent="#22C55E" testid="kpi-saldo" />
        <Kpi label="Total medido" value={fmtBRL(t.valor_medido)} testid="kpi-medido" />
        <Kpi label="Total aprovado" value={fmtBRL(t.valor_aprovado)} accent="#009C3B" testid="kpi-aprovado" />
        <Kpi label="Total pago" value={fmtBRL(t.valor_pago)} testid="kpi-pago" />
        <Kpi label="Disponível p/ medir" value={fmtBRL(t.saldo_disponivel)} accent="#3B82F6" testid="kpi-disponivel" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="tce-card p-6 lg:col-span-2">
          <div className="uppercase-label mb-4">Contratos por valor</div>
          {chart.length ? (
            <ResponsiveContainer width="100%" height={260}>
              <BarChart data={chart}>
                <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
                <XAxis dataKey="name" stroke="#94A3B8" fontSize={11} />
                <YAxis stroke="#94A3B8" fontSize={11} tickFormatter={(v) => `${(v / 1000).toFixed(0)}k`} />
                <Tooltip formatter={(v) => fmtBRL(v)} contentStyle={{ background: "#0F172A", border: "1px solid #334155" }} />
                <Legend />
                <Bar dataKey="Atualizado" fill="#FFDF00" />
                <Bar dataKey="Aprovado" fill="#009C3B" />
                <Bar dataKey="Saldo" fill="#3B82F6" />
              </BarChart>
            </ResponsiveContainer>
          ) : <p className="text-sm text-[#94A3B8]">Nenhum contrato vinculado ao seu cadastro.</p>}
        </div>
        <div className="tce-card p-6">
          <div className="uppercase-label mb-4 flex items-center gap-2"><ClipboardText size={14} /> Medições</div>
          <div className="space-y-2" data-testid="painel-medicoes-status">
            {Object.entries(STATUS).map(([k, s]) => (
              <Link key={k} to={`/fornecedor/medicoes?status=${k}`} className="flex justify-between text-sm hover:text-[#FFDF00]">
                <span className="flex items-center gap-2"><span className="w-2 h-2 rounded-full" style={{ background: s.color }} />{s.label}</span>
                <span className="font-mono" data-testid={`painel-med-${k}`}>{d.medicoes[k] || 0}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className="tce-card p-6">
        <div className="uppercase-label mb-4 flex items-center gap-2 !text-[#F59E0B]"><Warning size={14} /> Alertas</div>
        {!d.alertas.length && <p className="text-sm text-[#94A3B8]">Sem alertas no momento.</p>}
        <ul className="space-y-2" data-testid="painel-alertas">
          {d.alertas.map((a, i) => (
            <li key={i} className="flex items-center gap-3 text-sm">
              <FileText size={14} className="text-[#F59E0B]" />
              <Link to={a.medicao_id ? `/fornecedor/medicoes/${a.medicao_id}` : `/fornecedor/contratos/${a.contract_id}`} className="hover:text-[#FFDF00]">{a.texto}</Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
